import { Controller } from '@hotwired/stimulus';

// チェック済みの数が上限に達したら、未チェックのチェックボックスを無効化する
export default class extends Controller {
  static targets = ['checkbox'];
  static values = { max: Number };

  connect() {
    this.update();
  }

  update() {
    const limitReached =
      this.checkboxTargets.filter((checkbox) => checkbox.checked).length >=
      this.maxValue;
    for (const checkbox of this.checkboxTargets) {
      if (!checkbox.checked) {
        checkbox.disabled = limitReached;
      }
    }
  }
}
